import * as React from "react";
import { IconProps } from "./IconProps";

export const IconOffline = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <g id="cloud 2 off, offline ">
          <path
            id="Icon (Stroke)"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.52892 1.52859C1.78927 1.26824 2.21138 1.26824 2.47173 1.52859L14.4717 13.5286C14.7321 13.7889 14.7321 14.2111 14.4717 14.4714C14.2114 14.7318 13.7893 14.7318 13.5289 14.4714L12.3705 13.313C12.2488 13.3264 12.1253 13.3333 12.0003 13.3333H4.66699C2.45785 13.3333 0.666992 11.5425 0.666992 9.33333C0.666992 7.44574 1.97392 5.86435 3.73246 5.44324C3.80986 5.26868 3.89762 5.09982 3.99494 4.93743L1.52892 2.4714C1.26857 2.21105 1.26857 1.78894 1.52892 1.52859ZM4.97948 5.92196C4.93007 6.02751 4.88605 6.13603 4.84777 6.24717C4.76569 6.48545 4.55627 6.65708 4.30651 6.69075C3.00449 6.86627 2.00033 7.98308 2.00033 9.33333C2.00033 10.8061 3.19423 12 4.66699 12H11.0575L4.97948 5.92196ZM7.05268 2.76308C7.35924 2.6998 7.67627 2.66667 8.00033 2.66667C10.3717 2.66667 12.33 4.43543 12.6278 6.72563C14.1688 7.01915 15.3337 8.37354 15.3337 10C15.3337 10.338 15.2831 10.6653 15.1888 10.9744C15.0813 11.3265 14.7087 11.5248 14.3565 11.4173C14.0044 11.3098 13.8061 10.9372 13.9136 10.5851C13.9698 10.4008 14.0003 10.2046 14.0003 10C14.0003 8.89543 13.1049 8 12.0003 8C11.6321 8 11.3337 7.70152 11.3337 7.33333C11.3337 5.49238 9.84127 4 8.00033 4C7.76734 4 7.54063 4.0238 7.32224 4.06888C6.96165 4.14332 6.609 3.91134 6.53456 3.55076C6.46013 3.19017 6.6921 2.83751 7.05268 2.76308Z"
            fill={color}
          />
        </g>
      </svg>
    );
  },
);
